import React from 'react'
import StatusTable from '../StatusTable'

export default function ZoneStatus() {
  const tableData = (item, tableHeadings) => {
    let tempData = []
    tableHeadings && tableHeadings.map((val) => tempData.push({ ...val, value: item[val] }))

    return tempData
  }

  return <StatusTable tableData={tableData} module="ZONE" />
}
